module.exports = __webpack_public_path__ + "static/media/Scragg 18T Drive.05784d88.jpg";